// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_container__e5JuZ","btnStyles":"Carousel_btnStyles__6TA45","icon":"Carousel_icon__bI0B3","viewAll":"Carousel_viewAll__aE1iq","border":"Carousel_border__cBKXE"};